// ─────────────────────────────────────────────────────────────────────────────
// localStorage keys
// ─────────────────────────────────────────────────────────────────────────────
export const LAUNCH_TOKEN_KEY     = 'launch_token';
export const LAUNCH_GOOGLE_ID_KEY = 'launch_googleId';
export const LAUNCH_PROFILE_KEY   = 'launch_profile';

// ─────────────────────────────────────────────────────────────────────────────
// Internal module definition
// ─────────────────────────────────────────────────────────────────────────────
export interface InternalModule {
  id: string;
  name: string;
  description: string;
  path: string;
  icon: string;
  color: string;
}

export const MODULE_GEORREF: InternalModule = {
  id: 'georref',
  name: 'Georref',
  description: 'Georreferenciación de inmuebles',
  path: '/document-audit/georeferencing',
  icon: '📍',
  color: '#0ea5e9',
};

export const MODULE_POLYNATOR: InternalModule = {
  id: 'polynator',
  name: 'Polynator',
  description: 'Creación y edición de polígonos',
  path: '/polygons/dashboard-tools',
  icon: '📐',
  color: '#7c3aed',
};

export const MODULE_POLYGON_VIEWER: InternalModule = {
  id: 'polygon-viewer',
  name: 'Visor de polígonos',
  description: 'Visualización de polígonos',
  path: '/polygon-viewer/polygon-viewer-dashboard',
  icon: '🗺️',
  color: '#7c3aed',
};

export const MODULE_DOC_REVIEW: InternalModule = {
  id: 'doc-review',
  name: 'Revisión de docs',
  description: 'Auditoría y revisión de documentos',
  path: '/document-audit/tasks',
  icon: '📋',
  color: '#f59e0b',
};

export const MODULE_LA_CENTRAL: InternalModule = {
  id: 'la-central',
  name: 'La central',
  description: 'Comité de precios y orquestación',
  path: '/orchestrator-pricing-committee/dashboard-opc',
  icon: '🏛️',
  color: '#10b981',
};

// ─────────────────────────────────────────────────────────────────────────────
// Environment display config
// ─────────────────────────────────────────────────────────────────────────────
export const ENV_LABELS: Record<string, string> = {
  local: '🏠 Localhost',
  qa:    '🧪 QA (.llavero.co)',
  prod:  '🏢 Producción (.habi.co)',
};

export const ENV_COLORS: Record<string, string> = {
  local: '#f59e0b',
  qa:    '#3b82f6',
  prod:  '#10b981',
};

export const ENV_LABELS_SHORT: Record<string, string> = {
  local: 'Localhost',
  qa:    'QA (.llavero.co)',
  prod:  'Producción (.habi.co)',
};

export const SSO_METHODS: Record<string, string> = {
  local: '🔗 URL params',
  qa:    '🍪 Cookies compartidas',
  prod:  '🍪 Cookies compartidas',
};
